/* eslint-disable max-statements */
import PropTypes from "prop-types";
import classNames from "classnames";
import { format } from "date-fns-tz";

import { eventCancelled } from "../helpers/event";
import { getTimezone } from "../helpers/dates";

const RegistrationClosedMessage = ({
	className,
	course
}) => {
	const messageClasses = [];
	let message = "Registration is closed.";

	if (course.registrationOpen && course.registrationOpen > new Date()) {
		message = (
			<>
				<strong>Registration opens on:</strong><br />
				{format(course.registrationOpen, "E MMM do 'at' h:mm a z", { timeZone: getTimezone() })}
			</>
		);
		messageClasses.push("text-neutral3");
	} else {
		messageClasses.push("text-danger");
	}

	if (course.courseTiming?.noOnlineRegistration) {
		message = course.courseTiming?.customRegistrationMessage || "Please contact us to register.";
	}

	if (eventCancelled(course)) {
		message = "This event has been cancelled.";
	}

	if (course.availableSeats <= 0 && course.availableOnlineSeats <= 0) {
		message = "This event is full.";
	}

	return (
		<div className={classNames(messageClasses, className)}>
			{message}
		</div>
	);
};

RegistrationClosedMessage.propTypes = {
	className: PropTypes.string,
	course: PropTypes.shape({
		availableSeats: PropTypes.number,
		availableOnlineSeats: PropTypes.number,
		courseTiming: PropTypes.shape({
			customRegistrationMessage: PropTypes.string,
			eventCancelled: PropTypes.bool,
			noOnlineRegistration: PropTypes.bool
		}),
		registrationOpen: PropTypes.instanceOf(Date)
	}).isRequired
};

RegistrationClosedMessage.defaultProps = {
	className: ""
};

export default RegistrationClosedMessage;
